export default __webpack_public_path__ + "static/blob9-86841797f48f142bc8038de7c7375b96.svg";